import * as React from 'react';
import clsx from 'clsx';
import { Icon } from '../icon';
import { Typography } from '../typography';
import styles from './styles.module.css';
import { useStyleProps, colorToken } from '../utils';
const ICON_SIZE = 16;
/**
 * `<Label />` - Компонент для отображения текстового статуса элемента.
 *
 * @example ``` tsx
 <Label>Best buy</Label>
 * ```
 */
export const Label = /*#__PURE__*/React.forwardRef(function Label({
  className = '',
  color = 'text-primary',
  background = 'control-minor',
  variant = '',
  children,
  iconLeft,
  iconRight,
  borderColor,
  ...props
}, ref) {
  const styleProps = useStyleProps({
    color,
    background,
    borderColor: borderColor != null ? borderColor : background
  }, labelStyleProps);
  const classNames = React.useMemo(() => clsx(styles.label, styles[variant], className), [variant, className]);
  const title = typeof children === 'string' ? children : '';
  const labelProps = {
    ...styleProps,
    title,
    className: classNames,
    ref
  };
  return /*#__PURE__*/React.createElement("span", {
    ...labelProps,
    ...props
  }, iconLeft && /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZE
  }, iconLeft), /*#__PURE__*/React.createElement(Typography, {
    className: styles.textStyle,
    variant: "caption"
  }, children), iconRight && /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZE
  }, iconRight));
});
const labelStyleProps = {
  background: ['backgroundColor', colorValue],
  color: ['color', colorValue],
  borderColor: ['borderColor', colorValue]
};
function colorValue(value) {
  return colorToken(value);
}